module.exports = __webpack_public_path__ + "img/n1.a406e326.jpg";